import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { IMessageResItem, ISystemMessageReq } from '../../model/api-modules';
import {
  IAPIStudioMemberItem,
  IStudioInfo,
} from '../../model/api-modules/studio';
import { ADMIN_PREFIX } from '../config';

// 管理员获取所有工作室
export const getAdminAllStudio = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/studio`;
      const response = await api.commonRequest('GET', url);
      return await parsedResponse<IStudioInfo[]>(response, 'data');
    } catch (error) {
      return false;
    }
  });

// 管理员获取工作室所属的成员信息
export const getAdminAllMember = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/member/${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<Array<IAPIStudioMemberItem>>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return false;
    }
  });

export const getAdminMessage = (subType: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/message?subType=${subType}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<{ list: readonly IMessageResItem[] }>(
        response,
        'data'
      );
      return res.list;
    } catch (error) {
      return [];
    }
  });

export const getAdminMessageById = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/message/${id}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IMessageResItem>(response, 'data');
      return res;
    } catch (error) {
      return;
    }
  });

// 管理员创建消息模块-创建消息
export const postAdminMessage = (body: ISystemMessageReq) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/message`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });
